export default __webpack_public_path__ + "static/media/signup_two.32bb5360.png";